// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_ProcessDeductionDiscountsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { Payroll_ProcessDeductionDiscountsResultsRow } from './Payroll_ProcessDeductionDiscountsResultsRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_ProcessDeductionDiscountsResponseDados = Payroll_ProcessDeductionDiscountsResultsRow;

export type Payroll_ProcessDeductionDiscountsResponse = ApiResponse<Payroll_ProcessDeductionDiscountsResponseDados>;

registerResponseContract('Payroll_ProcessDeductionDiscountsResponse', {
  processed: {
    type: 'array',
    required: true,
    items: {
      deduction_id:      { type: 'number',  required: true },
      item_id:           { type: 'number',  required: false },
      deleted_item_id:   { type: 'number',  required: false },
      old_amount:        { type: 'number',  required: false },
      new_amount:        { type: 'number',  required: false },
      amount_difference: { type: 'number',  required: false },
      new_amount_paid:   { type: 'number',  required: false },
      new_status:        { type: 'number',  required: false },
      new_status_label:  { type: 'string',  required: false },
      is_update:         { type: 'boolean', required: false },
      error:             { type: 'string',  required: false },
    },
  },
  deleted: {
    type: 'array',
    required: true,
    items: {
      deduction_id:      { type: 'number',  required: true },
      item_id:           { type: 'number',  required: false },
      deleted_item_id:   { type: 'number',  required: false },
      old_amount:        { type: 'number',  required: false },
      new_amount:        { type: 'number',  required: false },
      amount_difference: { type: 'number',  required: false },
      new_amount_paid:   { type: 'number',  required: false },
      new_status:        { type: 'number',  required: false },
      new_status_label:  { type: 'string',  required: false },
      is_update:         { type: 'boolean', required: false },
      error:             { type: 'string',  required: false },
    },
  },
  errors: {
    type: 'array',
    required: true,
    items: {
      deduction_id:      { type: 'number',  required: true },
      item_id:           { type: 'number',  required: false },
      deleted_item_id:   { type: 'number',  required: false },
      old_amount:        { type: 'number',  required: false },
      new_amount:        { type: 'number',  required: false },
      amount_difference: { type: 'number',  required: false },
      new_amount_paid:   { type: 'number',  required: false },
      new_status:        { type: 'number',  required: false },
      new_status_label:  { type: 'string',  required: false },
      is_update:         { type: 'boolean', required: false },
      error:             { type: 'string',  required: false },
    },
  },
})
